import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
})
export class AccessDeniedComponent extends BaseComponent implements OnInit {

  constructor(
    private router : Router,
    private common_service:CommonService
  ){
    super()
  }

  ngOnInit(): void {
      
  }

  route(){
    const flag = this.common_service.validPermissionFound
    if(!flag){
      this.router.navigate([this.routingModuleType.authentication, this.routingAuthenticationModuleType.signin])
    }
  }
}
